export default __webpack_public_path__ + "static/media/negative.2d487a99.png";